import { config } from 'config'

export const useIsProdEnv = () => config.env === 'production'
